<script setup lang="ts">
import LoadingCircle from "../SVG/Loading.vue";
import GumbatiLogo from "../SVG/GumbatiLogo.vue";
import LoadingDots from "./parts/LoadingDots.vue";

/**
 * @author Alexander Kenchoshvili
 */

//

const props = withDefaults(
  defineProps<{
    icon?: boolean;
  }>(),
  {
    icon: true,
  }
);

const i18n = useI18n();

</script>

<template>
  <div data-loader class="loading d-flex j-center al-center pos-fixed">
    <div class="loading__wrapper">
      <div v-if="icon" class="loading__spinner d-flex dir-col al-center j-center br-8">
        <div class="loading__spinner--gumbati-icon">
          <!-- <GumbatiLogo /> -->
           <img
            v-if="i18n.locale.value == 'ka'"
            src="@/assets/images/logo/logo-ka-vertical.svg"
            width="73"
            height="120"
            alt="Logo"
          />

          <img
            v-else
            src="@/assets/images/logo/logo-eng-vertical.svg"
            width="73"
            height="120"
            alt="Logo"
          />
        </div>
        <div class="loading__circle d-flex j-center al-center">
          <LoadingCircle /> <LoadingDots />
        </div>
      </div>
      <div v-else class="loading__default d-flex dir-col al-center j-center br-8">
        <div class="loading__default-circle">
          <LoadingCircle />
        </div>
        <div class="loading__default-dots">
          <LoadingDots />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.loading {
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh; /* old browsers */
  height: 100dvh; /* new browsers */
  // background-color: rgba(0, 0, 0, 0.8);
  background-color: $white;
  z-index: 10001;

  &__spinner {
    width: 350px;
    height: 350px;
    background-color: $white;
    @include maxq(desktop-lg) {
      width: 200px;
      height: 200px;
    }
    &--gumbati-icon {
      width: 70%;
      img{
        width: 100%;
        height: 100%;
      }
      svg {
        width: 100%;
        height: 100%;
        display: inline-block;
      }
    }
  }
  &__circle {
    margin-top: 24px;
    @include maxq(desktop-lg) {
      margin-top: 14px;
    }
    .icon--loading {
      margin-right: 6px;
      animation: spin 2s linear infinite;
    }
    span {
      text-transform: capitalize;
    }
  }
  &__default {
    width: 250px;
    height: 250px;
    background-color: $white;
    @include maxq(desktop-lg) {
      width: 131px;
      height: 132px;
    }
    &-circle {
      animation: spin 2s linear infinite;
      svg {
        width: 50px;
        height: 50px;
        @include maxq(desktop-lg) {
          width: 30px;
          height: 30px;
        }
      }
    }
    &-dots {
      margin-top: 26px;
      @include maxq(desktop-lg) {
        margin-top: 13px;
      }
      .loading-dots {
        margin-right: 0px;
      }
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
